import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { common_urls } from 'src/environments/environment';
import { InactivityService } from './inactivity.service';

@Injectable({
  providedIn: 'root'
})
export class CwsRedirectService {
  private inactivityService = inject(InactivityService);
  private oidcSecurityService = inject(OidcSecurityService);

  cwsErrorPage: string = `${common_urls.cwsBaseUrl}/error_page`;

  isSafeUrl(url: string): boolean {
    return this.getSafeRedirectUrl(url) !== null;
  }

  private getSafeRedirectUrl(value: string): string | null {
    try {
      const decodedUrl = decodeURIComponent(value);
      const destination = new URL(decodedUrl.startsWith('https://') ? decodedUrl : `https://${decodedUrl}`);
      const trustedUrl = new URL(common_urls.cwsBaseUrl);
      const basePath = trustedUrl.pathname.replace(/\/+$/, '');

      if (destination.protocol !== 'https:' || trustedUrl.protocol !== 'https:' ||
          destination.origin !== trustedUrl.origin || destination.username || destination.password ||
          (destination.pathname !== basePath && !destination.pathname.startsWith(`${basePath}/`))) {
        return null;
      }

      const safeUrl = new URL(trustedUrl.origin);
      safeUrl.pathname = destination.pathname;
      safeUrl.search = destination.search;
      safeUrl.hash = destination.hash;
      return safeUrl.href;
    } catch {
      return null;
    }
  }

  /* Function to redirect user on cws */
  redirectToCWSBack() {
    this.inactivityService.stopTrackingInactivity();
    this.oidcSecurityService.logoffLocal();
    console.log('local logoff called');

    const url = sessionStorage.getItem('cwsBackUrl');

    //if url is empty or null or undefined it will simply return
    if(!url) return;

    const safeUrl = this.getSafeRedirectUrl(url);
    if (safeUrl) {
      window.open(safeUrl, '_self');
    }
  }

  /* Function to redirect user on cws error page */
  redirectToCWSErrorPage(): void {
    this.inactivityService.stopTrackingInactivity();
    this.oidcSecurityService.logoffLocal();
    window.open(this.cwsErrorPage, '_self');
  }

  /* Function to redirect user to cws procUrl (Procedure) url page */
  redirectToCwsProcUrl(): void {
    this.inactivityService.stopTrackingInactivity();
    this.oidcSecurityService.logoffLocal();
    const url = sessionStorage.getItem('procUrl');

    //if url is empty or null or undefined it'll return
    if(!url) return;

    let safeUrl = this.getSafeRedirectUrl(url);
    if (!safeUrl) return;

    if (safeUrl.indexOf('home') >= 0 || safeUrl.indexOf('policyinquiry') >= 0) {
      safeUrl += '&cws=1';
    }
    window.open(safeUrl, '_self');
  }
}